<template>
    <div class="img-wrapper">
        <div class="img-item"
             v-for="photo in photos" v-bind:key="photo"
             :style='`background-image: url("${photo}")`'>
        </div>

    </div>
</template>

<script>
export default {
    props: {
        photos: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style scoped>
    .img-wrapper{
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 0 80px;
    }

    @media (min-width: 992px) and (max-width: 1199px) {
        .img-wrapper{
            padding: 0 50px;
        }
    }
    @media (max-width: 992px) {
        .img-wrapper{
            padding: 0 10px;
        }
    }

    .img-item{
        width: 100%;
        margin: 5px;
        height: 250px;
        background-size: cover;
        background-position: 50% 50%;
    }
</style>
